import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Jurisdiction } from '../models/jurisdiction';

@Injectable({
  providedIn: 'root'
})
export class JurisdictionService {
    url = "api/jurisdictions";

    constructor(private dataService: DataService) { }

    async getAllJurisdictions(): Promise<Jurisdiction[]> {
        return await this.dataService.get<Jurisdiction[]>(this.url);
    }

    async createJurisdiction(jurisdiction: Jurisdiction): Promise<Jurisdiction> {
        return await this.dataService.post<Jurisdiction>(this.url, jurisdiction);
    }

    async updateJurisdiction(id: number, jurisdiction: Jurisdiction): Promise<Jurisdiction> {
        return await this.dataService.put<Jurisdiction>(this.url, jurisdiction, id);
    }

    async deleteJurisdiction(id: number): Promise<boolean> {
        return await this.dataService.delete<boolean>(this.url, id);
    }
}
